export enum TwoFactorReturnMode {
  STRICT = 'STRICT',
  NON_STRICT = 'NON_STRICT',
}
